import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-issue" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "required-red" }, "*", -1)
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "label-with-status" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "header-issue" }
const _hoisted_9 = { class: "header-issue" }
const _hoisted_10 = { class: "btn-bottom" }

import {
  ImageLossAlert,
  SamplingPointImageStatus,
  IssueType,
  IssueDiagnosis,
} from "@/types/issueMonitoring.type";
import { ref, onMounted, computed, reactive, watch } from "vue";
import { getSamplingPointsImageStatus } from "@/service/samplingPointImageStatus.service";
import { Filter } from "@/types/filter.type";
import { getIssueType, postIssueType } from "@/service/issueType.service";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { Station } from "@/types/station.type";
import { CircleCheck, CircleClose } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";
import { useI18n } from "vue-i18n";
import {
  postImageLossAlert,
  getIssueOptions,
  getDiagnosis,
  getExecution,
} from "@/service/imagelossalert.service";
import type { FormRules } from "element-plus";
import { UserAccess } from "@/types/auth.type";
import { getIssueDiagnosis } from "@/service/issueDiagnosis.service";


export default /*#__PURE__*/_defineComponent({
  emits: ["close", "getIssue"],
  setup(__props, { emit }: { emit: ({ (e: "close"): void; (e: "getIssue"): void }), expose: any, slots: any, attrs: any }) {

const samplingpoints = ref<SamplingPointImageStatus[]>([]);
const store = useStore<RootState>();

const issueTypeList = ref<IssueType[]>([]);
const activeName = ref("first");
const user: UserAccess = computed(() => store.state.auth.user);

const cameras = ref<{ label: string; value: string; modele: boolean }[]>([]);
const camerasWithIssue = ref<string[]>([]);
const visibleSearch = ref(false);

const issue = ref<ImageLossAlert>({
  status: true,
  origin: "MANUAL",
  reviewStatus: "UNREVIEWED",
  statusIssue: "UNREVIEWED",
  priority: "LOW",
  type: undefined,
} as unknown as ImageLossAlert);

const issueDiagnosis = ref<IssueDiagnosis>({
  isManual: true,
  status: "UNREVIEWED",
  diagnosis_manual: "",
  solution_proposal_manual: "",
} as IssueDiagnosis);

const customer = ref("");
const { t } = useI18n();

const filteredDiagnoses = ref<string[]>([]);
const filteredProposals = ref<string[]>([]);

const selectedDiagnosisOption = ref("");
const selectedProposalOption = ref("");
const customIssueText = ref("");
const customDiagnosisText = ref("");
const customProposalText = ref("");



const rules = reactive<FormRules<ImageLossAlert>>({
  samplingPoint: [
    { required: true, message: "Punto de monitorización requerido", trigger: "blur" },
  ],
  fromDateTime: [{ required: true, message: "Fecha requerida", trigger: "blur" }],
});

onMounted(async () => {
  try {
    const filter: Filter = {
      fields: { "samplingpointimagestatus.stationOperation": { operator: "equal", value: true } },
    };
    samplingpoints.value = (await getSamplingPointsImageStatus(undefined, undefined, filter)).data;

    issueTypeList.value = await getIssueType();

    filteredDiagnoses.value = (await getDiagnosis()).data.map((_) => _.name);
    filteredProposals.value = (await getExecution()).data.map((_) => _.name);
  } catch (err) {
    console.error("Error inicializando datos:", err);
    ElMessage.error("Error al cargar las opciones de diagnóstico globales");
  }
});

watch(
  () => issue.value.type,
  () => {
    selectedDiagnosisOption.value = "";
    selectedProposalOption.value = "";
    customDiagnosisText.value = "";
    customProposalText.value = "";
    customIssueText.value = "";
  },
  { deep: true }
);

const isCreatedIssue = () => {
  return (
    !issue.value.samplingPoint ||
    !issue.value.type ||
    !issue.value.fromDateTime ||
    camerasWithIssue.value.length === 0
  );
};

const beforeLeave = (newName: string) => {
  if (newName === "second" && isCreatedIssue()) {
    ElMessage.warning(
      `${t("warning.notIssue", { type: `"${t("label.mainInfo")}"`.toLowerCase() })}`
    );
    return false;
  }
  return true;
};

const getCameras = async () => {
  cameras.value = [];
  if (issue.value.samplingPoint?.id) {
    const samplingPoint = await getSamplingPointById(issue.value.samplingPoint.id);
    if ((samplingPoint.station as Station)?.id) {
      const camerasConfiguration = await getCamerasConfigurationByStationId(
        (samplingPoint.station as Station).id
      );
      camerasConfiguration?.forEach((_) => {
        cameras.value.push({ label: _.camera.code, value: _.camera.code, modele: _.modele });
      });
      customer.value = samplingPoint.container.holder;
    }
  }
};

const saveIssue = async () => {
  if (isCreatedIssue()) {
    ElMessage.warning(
      `${t("warning.notIssue", { type: `"${t("label.mainInfo")}"`.toLowerCase() })}`
    );
    return;
  }

  issueDiagnosis.value.diagnosis_manual =
    selectedDiagnosisOption.value === "Otros"
      ? customDiagnosisText.value
      : selectedDiagnosisOption.value;

  issueDiagnosis.value.solution_proposal_manual =
    selectedProposalOption.value === "Otros"
      ? customProposalText.value
      : selectedProposalOption.value;

  if (issue.value.reviewStatus === "REVIEWED" && issueDiagnosis.value.status === "UNREVIEWED") {
    issue.value.statusIssue = "IS-REVIEWED";
  } else if (
    issue.value.reviewStatus === "REVIEWED" &&
    issueDiagnosis.value.status !== "UNREVIEWED"
  ) {
    issue.value.statusIssue = `DI-${issueDiagnosis.value.status}`;
  }

  for (const camera of camerasWithIssue.value) {
    const payload = {
      ...issue.value,
      camera,
      fromDateTime: new Date(issue.value.fromDateTime).toISOString(),
      issueDiagnosis: { ...issueDiagnosis.value },
    };

    const newIssue = await postImageLossAlert(payload);
    if (newIssue) {
      ElNotification.success({
        message: `${t("success.action")} <br/> ${t("label.issueId")}: <b>${newIssue.code}</b>`,
        offset: 100,
        dangerouslyUseHTMLString: true,
      });
    }
  }

  emit("getIssue");
  cancelIssue();
};

const cancelIssue = () => {
  emit("close");
};

const openEntityFormDialog = () => {
  visibleSearch.value = true;
};

const setDiagnosis = () => {
  if (issue.value.reviewStatus === "UNREVIEWED" && issueDiagnosis.value.status !== "UNREVIEWED") {
    ElMessage.error("Es necesario que la incidencia se de como revisada primero.");
    issueDiagnosis.value.status = "UNREVIEWED";
  }
};

const saveTypeIssue = async (nameIssue: string) => {
  const newIssue = {} as IssueType;
  newIssue.name = nameIssue;
  await postIssueType(newIssue);
  visibleSearch.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((activeName).value = $event)),
    class: "demo-tabs",
    "before-leave": beforeLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.mainInfo'),
        name: "first"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "card-bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.mainInfo")), 1)
              ]),
              _createVNode(_component_el_form, {
                ref: "ruleFormRef",
                model: issue.value,
                rules: _unref(rules),
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.samplingPoint'),
                            prop: "samplingPoint"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.samplingPoint,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((issue.value.samplingPoint) = $event)),
                                "value-key": "id",
                                filterable: "",
                                style: {"width":"90%"},
                                onChange: getCameras
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingpoints.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.samplingPoint.id,
                                      label: item.samplingPoint.name,
                                      value: item.samplingPoint
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.customer')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(customer.value ?? "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.identification'),
                            prop: "origin"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issue.value.origin?.charAt(0).toUpperCase() + issue.value.origin?.slice(1).toLowerCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible'),
                            prop: "responsible"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(issue.value.responsable?.email), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.issueDescription'),
                            prop: "type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((issue.value.type) = $event)),
                                "value-key": "id",
                                style: {"width":"90%"},
                                placeholder: "Selecciona tipo de incidencia",
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueTypeList.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_popover, {
                                placement: "bottom",
                                width: 250,
                                visible: visibleSearch.value,
                                "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visibleSearch).value = $event))
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    class: "btn",
                                    type: "primary",
                                    size: "small",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (openEntityFormDialog())),
                                    circle: "",
                                    disabled: (issue.value.type && issue.value.type.name !== 'Otros') || !issue.value.type
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                default: _withCtx(() => [
                                  (issue.value.type && issue.value.type.name === 'Otros')
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: customIssueText.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customIssueText).value = $event)),
                                        placeholder: "Escriba una nueva incidencia...",
                                        style: {"margin-top":"10px"}
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (saveTypeIssue(customIssueText.value)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["visible"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.reviewStatus')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.reviewStatus,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((issue.value.reviewStatus) = $event)),
                                filterable: "",
                                style: {"width":"90%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Sin Revisar",
                                    value: "UNREVIEWED"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Revisado",
                                    value: "REVIEWED"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.priority')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issue.value.priority,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((issue.value.priority) = $event)),
                                style: {"width":"90%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Baja",
                                    value: "LOW"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Media",
                                    value: "MEDIUM"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Alta",
                                    value: "HIGH"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.startDate'),
                            prop: "fromDateTime"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: issue.value.fromDateTime,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((issue.value.fromDateTime) = $event)),
                                type: "datetime",
                                format: "YYYY-MM-DD HH:mm",
                                placeholder: "DD/MM/AAAA hh:mm",
                                style: {"width":"90%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.endDateTime'),
                            prop: "toDateTime"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: issue.value.endDateTime,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((issue.value.endDateTime) = $event)),
                                type: "datetime",
                                format: "YYYY-MM-DD HH:mm",
                                placeholder: "DD/MM/AAAA hh:mm",
                                style: {"width":"90%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.observations')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issue.value.observation,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((issue.value.observation) = $event)),
                                maxlength: "150",
                                "show-word-limit": "",
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-bottom",
            gutter: 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.incident_cancellation")), 1),
                      _createVNode(_component_el_form, {
                        model: issue.value,
                        "label-width": "180px",
                        "label-position": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { gutter: 10 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.statusIssue')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        modelValue: issue.value.status,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((issue.value.status) = $event)),
                                        disabled: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: _ctx.$t('label.note')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: issue.value.note,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((issue.value.note) = $event)),
                                        rows: 2,
                                        autosize: { maxRows: 2, minRows: 2 },
                                        maxlength: "100",
                                        "show-word-limit": "",
                                        type: "textarea"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "never" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("label.camera")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        (cameras.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: camerasWithIssue.value,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((camerasWithIssue).value = $event)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameras.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                      key: item.value,
                                      label: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_6, [
                                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                          (item.modele)
                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 0,
                                                color: "#67C23A"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleCheck))
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 1,
                                                color: "#F56C6C"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CircleClose))
                                                ]),
                                                _: 1
                                              }))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("warning.notCameras")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_tab_pane, {
        label: _ctx.$t('label.diagnosis'),
        name: "second"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: issue.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")) + " " + _toDisplayString(_ctx.$t("label.manual").toLowerCase()), 1)
                  ]),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.responsible')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(user)?.email), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.diagnosis')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: selectedDiagnosisOption.value,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedDiagnosisOption).value = $event)),
                                style: {"width":"100%","margin-bottom":"10px"},
                                placeholder: "Selecciona un diagnóstico",
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDiagnoses.value, (opt) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: opt,
                                      label: opt,
                                      value: opt
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (selectedDiagnosisOption.value === 'Otros')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: customDiagnosisText.value,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customDiagnosisText).value = $event)),
                                    placeholder: "Escribe el diagnóstico personalizado",
                                    maxlength: "150",
                                    "show-word-limit": "",
                                    type: "textarea"
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('label.solution_proposal')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: selectedProposalOption.value,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedProposalOption).value = $event)),
                                style: {"width":"100%","margin-bottom":"10px"},
                                placeholder: "Selecciona una propuesta de solución",
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProposals.value, (opt) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: opt,
                                      label: opt,
                                      value: opt
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (selectedProposalOption.value === 'Otros')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: customProposalText.value,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((customProposalText).value = $event)),
                                    placeholder: "Escribe la propuesta personalizada",
                                    maxlength: "150",
                                    "show-word-limit": "",
                                    type: "textarea"
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, {
            class: "card-bottom",
            shadow: "never"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: issue.value,
                "label-width": "180px",
                "label-position": "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.diagnosis")), 1)
                  ]),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "Estado " }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: issueDiagnosis.value.status,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((issueDiagnosis.value.status) = $event)),
                                filterable: "",
                                style: {"width":"50%"},
                                onChange: _cache[19] || (_cache[19] = ($event: any) => (setDiagnosis()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Sin Revisar",
                                    value: "UNREVIEWED"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "En Proceso",
                                    value: "IN_PROGRESS"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Revisado",
                                    value: "REVIEWED"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "Anotación" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: issueDiagnosis.value.note,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((issueDiagnosis.value.note) = $event)),
                                maxlength: "100",
                                "show-word-limit": "",
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: cancelIssue }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveIssue
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})